module.exports = __webpack_public_path__ + "img/logo.4637ed8e.png";